webpackJsonp([13],{

/***/ 1880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(268);

var _redux = __webpack_require__(1);

var _timezone = __webpack_require__(1178);

var _general = __webpack_require__(113);

var _route = __webpack_require__(1179);

var _logged_in = __webpack_require__(1881);

var _logged_in2 = _interopRequireDefault(_logged_in);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2017 Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

function mapStateToProps(state, ownProps) {
    var license = (0, _general.getLicense)(state);
    var config = (0, _general.getConfig)(state);

    return {
        mfaRequired: (0, _route.checkIfMFARequired)(license, config, ownProps.match.url),
        enableTimezone: config.ExperimentalTimezone === 'true'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: (0, _redux.bindActionCreators)({
            autoUpdateTimezone: _timezone.autoUpdateTimezone
        }, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_logged_in2.default);

/***/ }),

/***/ 1881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(264);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(263);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(267);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(265);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(266);

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = __webpack_require__(773);

var _jquery2 = _interopRequireDefault(_jquery);

var _propTypes = __webpack_require__(22);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(14);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(1882);

var _channels = __webpack_require__(798);

var _global_actions = __webpack_require__(778);

var GlobalActions = _interopRequireWildcard(_global_actions);

var _websocket_actions = __webpack_require__(1030);

var WebSocketActions = _interopRequireWildcard(_websocket_actions);

__webpack_require__(829);

var _user_store = __webpack_require__(774);

var _user_store2 = _interopRequireDefault(_user_store);

var _channel_store = __webpack_require__(785);

var _channel_store2 = _interopRequireDefault(_channel_store);

var _error_store = __webpack_require__(847);

var _error_store2 = _interopRequireDefault(_error_store);

var _user_agent = __webpack_require__(790);

var UserAgent = _interopRequireWildcard(_user_agent);

var _utils = __webpack_require__(762);

var Utils = _interopRequireWildcard(_utils);

var _loading_screen = __webpack_require__(792);

var _loading_screen2 = _interopRequireDefault(_loading_screen);

var _timezone = __webpack_require__(962);

var _redux_store = __webpack_require__(271);

var _redux_store2 = _interopRequireDefault(_redux_store);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright (c) 2016-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

var dispatch = _redux_store2.default.dispatch;
var getState = _redux_store2.default.getState;

var BACKSPACE_CHAR = 8;

var LoggedIn = function (_React$Component) {
    (0, _inherits3.default)(LoggedIn, _React$Component);

    function LoggedIn(params) {
        (0, _classCallCheck3.default)(this, LoggedIn);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LoggedIn.__proto__ || (0, _getPrototypeOf2.default)(LoggedIn)).call(this, params));

        _this.onUserChanged = _this.onUserChanged.bind(_this);

        _this.state = {
            user: _user_store2.default.getCurrentUser()
        };
        document.getElementById('root').className += ' channel-view';
        return _this;
    }

    (0, _createClass3.default)(LoggedIn, [{
        key: 'isValidState',
        value: function isValidState() {
            return this.state.user != null;
        }
    }, {
        key: 'onUserChanged',
        value: function onUserChanged() {
            // Grab the current user
            var user = _user_store2.default.getCurrentUser();

            if (!Utils.areObjectsEqual(this.state.user, user)) {
                this.setState({
                    user: user
                });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            _error_store2.default.clearLastError();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Initialize websocket
            WebSocketActions.initialize();

            if (this.props.enableTimezone) {
                this.props.actions.autoUpdateTimezone((0, _timezone.getBrowserTimezone)());
            }

            // Make sure the websockets close and reset version
            (0, _jquery2.default)(window).on('beforeunload', function () {
                // Turn off to prevent getting stuck in a loop
                (0, _jquery2.default)(window).off('beforeunload');
                if (document.cookie.indexOf('MMUSERID=') > -1) {
                    (0, _channels.viewChannel)('', _channel_store2.default.getCurrentId() || '')(dispatch, getState);
                }
                WebSocketActions.close();
            });

            // Listen for user
            _user_store2.default.addChangeListener(this.onUserChanged);

            // Listen for focused tab/window state
            window.addEventListener('focus', this.onFocusListener);
            window.addEventListener('blur', this.onBlurListener);

            // Because current CSS requires the root tag to have specific stuff

            // Device tracking setup
            if (UserAgent.isIos()) {
                (0, _jquery2.default)('body').addClass('ios');
            } else if (UserAgent.isAndroid()) {
                (0, _jquery2.default)('body').addClass('android');
            }

            if (!this.state.user) {
                (0, _jquery2.default)('#root').attr('class', '');
                GlobalActions.emitUserLoggedOutEvent('/login?redirect_to=' + encodeURIComponent(this.props.location.pathname));
            }

            (0, _jquery2.default)('body').on('mouseenter mouseleave', '.post', function mouseOver(ev) {
                if (ev.type === 'mouseenter') {
                    (0, _jquery2.default)(this).parent('div').prev('.date-separator, .new-separator').addClass('hovered--after');
                    (0, _jquery2.default)(this).parent('div').next('.date-separator, .new-separator').addClass('hovered--before');
                } else {
                    (0, _jquery2.default)(this).parent('div').prev('.date-separator, .new-separator').removeClass('hovered--after');
                    (0, _jquery2.default)(this).parent('div').next('.date-separator, .new-separator').removeClass('hovered--before');
                }
            });

            (0, _jquery2.default)('body').on('mouseenter mouseleave', '.search-item__container .post', function mouseOver(ev) {
                if (ev.type === 'mouseenter') {
                    (0, _jquery2.default)(this).closest('.search-item__container').find('.date-separator').addClass('hovered--after');
                    (0, _jquery2.default)(this).closest('.search-item__container').next('div').find('.date-separator').addClass('hovered--before');
                } else {
                    (0, _jquery2.default)(this).closest('.search-item__container').find('.date-separator').removeClass('hovered--after');
                    (0, _jquery2.default)(this).closest('.search-item__container').next('div').find('.date-separator').removeClass('hovered--before');
                }
            });

            (0, _jquery2.default)('body').on('mouseenter mouseleave', '.post.post--comment.same--root', function mouseOver(ev) {
                if (ev.type === 'mouseenter') {
                    (0, _jquery2.default)(this).parent('div').prev('.date-separator, .new-separator').addClass('hovered--comment');
                    (0, _jquery2.default)(this).parent('div').next('.date-separator, .new-separator').addClass('hovered--comment');
                } else {
                    (0, _jquery2.default)(this).parent('div').prev('.date-separator, .new-separator').removeClass('hovered--comment');
                    (0, _jquery2.default)(this).parent('div').next('.date-separator, .new-separator').removeClass('hovered--comment');
                }
            });

            // Prevent backspace from navigating back a page
            (0, _jquery2.default)(window).on('keydown.preventBackspace', function (e) {
                if (e.which === BACKSPACE_CHAR && !(0, _jquery2.default)(e.target).is('input, textarea')) {
                    e.preventDefault();
                }
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            WebSocketActions.close();
            _user_store2.default.removeChangeListener(this.onUserChanged);

            (0, _jquery2.default)('body').off('click.userpopover');
            (0, _jquery2.default)('body').off('mouseenter mouseleave', '.post');
            (0, _jquery2.default)('body').off('mouseenter mouseleave', '.post.post--comment.same--root');

            (0, _jquery2.default)('.modal').off('show.bs.modal');

            (0, _jquery2.default)(window).off('keydown.preventBackspace');

            // Listen for focussed tab/window state
            window.removeEventListener('focus', this.onFocusListener);
            window.removeEventListener('blur', this.onBlurListener);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.isValidState()) {
                return _react2.default.createElement(_loading_screen2.default, null);
            }

            if (this.props.location.pathname !== '/mfa/setup' && this.props.mfaRequired) {
                return _react2.default.createElement(_reactRouter.Redirect, { to: '/mfa/setup' });
            }

            return this.props.children;
        }
    }, {
        key: 'onFocusListener',
        value: function onFocusListener() {
            GlobalActions.emitBrowserFocus(true);
        }
    }, {
        key: 'onBlurListener',
        value: function onBlurListener() {
            GlobalActions.emitBrowserFocus(false);
        }
    }]);
    return LoggedIn;
}(_react2.default.Component);

exports.default = LoggedIn;


LoggedIn.propTypes = {
    children: _propTypes2.default.object,
    mfaRequired: _propTypes2.default.bool.isRequired,
    enableTimezone: _propTypes2.default.bool.isRequired,
    actions: _propTypes2.default.shape({
        autoUpdateTimezone: _propTypes2.default.func.isRequired
    }).isRequired
};

/***/ }),

/***/ 1882:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(286);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ })

});


// WEBPACK FOOTER //
// 13.7f8aaa22b94a8ed2e02b.js